import {flattenKeys} from 'common/utils';
import {get} from 'lodash';
import {FieldValues, Path, UseFormSetError, UseFormSetValue, UseFormWatch} from 'react-hook-form';

export const setErrorsFactory = <T extends FieldValues>(
   setError: UseFormSetError<T>,
   setValue: UseFormSetValue<T>,
   watch: UseFormWatch<T>,
   _fields: any
) => (errors: any) => {
   const flatterErrors = flattenKeys(errors) as Path<T>[];
   flatterErrors.forEach((fE) => {
      if (get(_fields, fE)) {
         setError(fE, {type: 'custom', message: get(errors, fE)});
         // set touched
         setValue(fE, watch(fE) as any, {shouldTouch: true});
      }
   });
};

export const setSubmittingFactory = () => (state: boolean) =>
   console.debug('Form setSubmitting', state);

export const SetValuePristineOptions = {
   shouldDirty: false,
   shouldTouch: false,
   shouldValidate: false,
};
export const SetValueOptions = {shouldDirty: true, shouldTouch: true, shouldValidate: true};
